import React, { Fragment } from 'react';
import { NavLink } from 'redux-first-router-link';
import './authorBiosStyle.scss';
import SecondaryAuthorBio from './SecondaryAuthorBio';
import MetaTags from '../../common/MetaTags';
import { getHighResolutionAuthorImage } from './utils';
import {
  getFileName, isValid, isText, trimmed, decodeTags, makeAuthorImgLink,
} from '../../../utils';
import { AUTHOR_IMAGE_PLACEHOLDER } from '../../../consts';

const AuthorBios = ({
  author,
  secondaryAuthor,
  isMobile,
}) => {
  let authorImg = isValid(author.image) ? author.image : AUTHOR_IMAGE_PLACEHOLDER;
  authorImg = (authorImg !== AUTHOR_IMAGE_PLACEHOLDER) ? getHighResolutionAuthorImage(makeAuthorImgLink(authorImg)) : authorImg;
  const authorUrl = isValid(author.link) ? `/author/${author.link}` : null;
  const authorTitle = isValid(author.title) ? author.title : 'Title Placeholder';
  const className = 'bio-article';
  const authorName = isValid(author.name) ? author.name : null;
  const authorBio = isValid(author.description) ? decodeTags(author.description) : null;
  const hasSecondaryAuthor = isValid(secondaryAuthor);

  const renderedAuthor = (
    <>
      <div className="author-content-article">
        <div className={className}>
          <div className="author-img-container">
            {isMobile && <img className="top-card-img-mobile" src={authorImg} alt={getFileName(authorImg)} loading="lazy" />}
            {!isMobile && <img className="top-card-img-nonmobile" src={authorImg} alt={getFileName(authorImg)} loading="lazy" />}
          </div>
          <div className='author-card'>
            <h3 className='author-name'><NavLink to={authorUrl} target="_blank">{authorName}</NavLink></h3>
            <h3 className='author-title'>{authorTitle}</h3>
            <div className='author-bio' dangerouslySetInnerHTML={{ __html: authorBio }}></div>
            <div className='full-bio-link'><NavLink to={authorUrl} target="_blank">read full bio</NavLink></div>
          </div>
        </div>
      </div>
    </>
  );

  const bioBorder = (
    <hr className='hr-div'></hr>
  );

  return (
    <>
      <div className='author-content-wrapper'>
        {bioBorder}
        {renderedAuthor}
        {bioBorder}
        {hasSecondaryAuthor && <SecondaryAuthorBio secondaryAuthor={secondaryAuthor} isMobile={isMobile} />}
        {hasSecondaryAuthor && bioBorder}
      </div>
    </>
  );
};

export default AuthorBios;
